import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I reverse-engineered Hacker News",
  "description": "",
  "published": "2017-08-03T00:00:00.000Z",
  "redirect_from": ["/blog/reverse-engineered-hacker-news/swizec/7741"],
  "categories": "Learning, Technical",
  "hero": "./img/photos-images-original-000-415-209-3b4.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://github.com/HackerNews/API"
      }}>{`Hacker News has a public API`}</a>{`, and it's great. Live frontpage updates, live upvote counts, live comments. Everything you want or need at the tip of your fingers in real-time.`}</p>
    <p>{`But there's no write. You can't login, you can't upvote, and you can't post. You can't do anything but read. And you need writes to make a `}<a parentName="p" {...{
        "href": "https://school.shoutem.com/lectures/hacker-news-app-part-2-upvoting-commenting/"
      }}>{`Hacker News App`}</a>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "500px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3207de7084ad1330a0c1371a5a1c6f8e/0b533/photos-images-original-000-415-209-3b4.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.78026905829597%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'251\\'%20viewBox=\\'0%200%20400%20251\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M222%2079c-12%201-29%205-34%209-8%206-16%2022-17%2036l-2%207v3l2%205c0%205%205%2020%209%2025l2%205-4%2037a871%20871%200%20014%2026c0%202-1%202-8%202h-8v-3c0-5-5-5-44-5-32%200-33%200-33-2%200-1%202-2%2021-2h20l6-5%205-6-1-9a21159%2021159%200%2001-18-87l-46-1H32l-5%204-6%204%201%2010%201%2010%204%2014a20598%2020598%200%200011%2047v16c-1%2016%201%2014-20%2014l-18%201%2017%201h17l-2%203c-6%207-6%207%2025%207l28-1%2018-1%2019-1%2010-1c13%200%2034-2%2035-4%200-1%2016-2%2016%200h5a358%20358%200%200164%201c2-2%204-2%2025-2h22a780%20780%200%2000-71%2013l-10%202h8l18-2a1849%201849%200%200163-11l1%207c0%205%200%206%202%206s2-15%200-17l-16-1h-16l-1-3c0-11-4-30-10-42l-3-9-1-4c-1-1%201-3%207-9l11-17%205-8v-14c0-11-1-15-2-19-6-17-21-27-39-29a455%20455%200%2001-23%200m-5%203a88%2088%200%2000-21%205c-11%204-21%2020-23%2037v7h4c15%202%2014%202%2015%200%200-2%202-3%203%200l-2%203-2%206c0%204-5%207-11%207-5%200-5%201-1%2010%203%207%205%207%208%203l3-4h9c15%200%2019%202%2030%2018l7%209c3%200%209-2%2010-4l2-1c2%201%2012-7%2020-14%2018-20%2021-44%208-65-9-14-33-21-59-17M32%20117l-4%203-3%203h85l1%203%204%2018a1559%201559%200%200015%2068l1%205%204-3%203-4-1-6a1549%201549%200%2000-8-41l-6-32-4-14H32m-8%2016l2%208%2037%201%2036%201%205-8%204-8-42-1H24v7m181-5c-1%201%200%203%201%204%202%201%203%204%203%207%201%207%204%2010%2015%209%2015%200%2024-8%2018-17-1-2-2-2-11-2l-15%202c-4%201-9%200-9-3h-2m-99%209l-4%206%204%2016%2010%2045c2%2011%202%2011%207%2013l5%201v-3a365%20365%200%2000-8-39%201116%201116%200%2001-10-45l-4%206m125-5a400%20400%200%2000-18%202c-2%200-2%200-2%204l3%206c7%207%2032-2%2027-10-1-2-2-2-10-2m-57%206l1%205c5%204%2013%201%2014-5v-3l-8-1-8-1%201%205m-147%208a296%20296%200%20017%2030l5%2021%201%206%201-5a4701%204701%200%20014-27l1-9h19c20%200%2022%200%2020%202l-18%201-19-1-1%2010a2169%202169%200%2001-7%2056c0%201%200%202%2020%202h20l1-15a21697%2021697%200%20016-48c0-6%202-9%205-7l2%2010c1%209%201%2014-2%2032l-1%2010-1%204h26l-1-3a629%20629%200%2000-16-69%20558%20558%200%2000-72%200m171%2015l-3%201h-2c-3-2-6%200-7%204-1%205%2010%2014%2023%2018h23l-13-18c-3-3-8-5-8-4h-2c-2-1-7-2-11-1m-108%208l-3%2016-3%2029-1%2014c0%202%203%203%203%200a168%20168%200%20014-25l1-11v-20c0-4-1-5-1-3m94%204c-2%209-3%2030-2%2043%202%2018%202%2017%205%2018l13-7%205-5c5-3%2020-17%2027-26%208-7%207-8-10-8-10%200-13-1-18-3-6-2-15-9-18-12l-2-2v2m68%207l-9%207c-3%204-3%205%201%2013l3%2010%202%206%202%2010%201%205c2%202%206-16%209-36%201-8%201-9-1-13l-2-5-6%203m12%2014l-2%2012c-1%209-4%2021-6%2025-2%203-1%203%209%202h9v-6a93%2093%200%2000-8-34c-1-3-2-2-2%201m-36%2011c-9%209-21%2020-31%2027l-2%202h54l-1-4a149%20149%200%2000-9-34c0-2-1-1-11%209m-78%2027c0%206%200%206%208%205h6v-4l-1-3c-1%201-3%200-5-1-7-2-8-2-8%203m-35-1l-16%201c-15%200-21%201-15%202l2%204v3h16c18%200%2020%200%2016-5-2-1-2-2-1-3l3%202%202%203h26v-9h-16c-14%200-17%200-17%202m-80%207l-3%205c1%201%2052-1%2052-2l-1-4-1-3H38l-3%204\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3207de7084ad1330a0c1371a5a1c6f8e/ca0a1/photos-images-original-000-415-209-3b4.webp 223w", "/static/3207de7084ad1330a0c1371a5a1c6f8e/75680/photos-images-original-000-415-209-3b4.webp 445w", "/static/3207de7084ad1330a0c1371a5a1c6f8e/b0a15/photos-images-original-000-415-209-3b4.webp 500w"],
              "sizes": "(max-width: 500px) 100vw, 500px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3207de7084ad1330a0c1371a5a1c6f8e/e92b6/photos-images-original-000-415-209-3b4.png 223w", "/static/3207de7084ad1330a0c1371a5a1c6f8e/e66bf/photos-images-original-000-415-209-3b4.png 445w", "/static/3207de7084ad1330a0c1371a5a1c6f8e/0b533/photos-images-original-000-415-209-3b4.png 500w"],
              "sizes": "(max-width: 500px) 100vw, 500px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/3207de7084ad1330a0c1371a5a1c6f8e/0b533/photos-images-original-000-415-209-3b4.png",
              "alt": "photos images original 000 415 209 3b4",
              "title": "photos images original 000 415 209 3b4",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Without a public write API, the only thing left to do was to reverse engineer HackerNews forms and fake them with `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` requests. Technically, this falls under `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Cross-site_request_forgery"
      }}>{`cross site request forgery`}</a>{`, but it isn't malicious.`}</p>
    <p>{`Sure, we're pretending that we're a browser that's submitting forms, but we do what the user expects. That makes it okay, I think. HackerNews allows it at least. `}<a parentName="p" {...{
        "href": "#fn1"
      }}>{`1`}</a>{` `}<em parentName="p">{`shrug`}</em></p>
    <p>{`So how do you approach this sort of problem?`}</p>
    <p>{`It happens in 3 steps:`}</p>
    <ol>
      <li parentName="ol">{`Do the action`}</li>
      <li parentName="ol">{`Inspect the request`}</li>
      <li parentName="ol">{`Fake the request`}</li>
    </ol>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://gist.github.com/Swizec/de31ad9f995b0ad6bfe84dafd92e1e53"
      }}>{`Unofficial HN write API wrapper`}</a>{` lives as a Gist. I'm tempted to release it as an NPM module. Should I?`}</p>
    <p>{`I'm going to show you how this works on two examples: A Login form and an Upvote button. The first is a normal POST request; the second is a GET request with some fakery protection.`}</p>
    <h2 {...{
      "id": "do-the-action"
    }}>{`Do the action`}</h2>
    <p>{`HackerNews's login form looks like this:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/login-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`Which in HTML looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<form method="post" action="login">
  <input type="hidden" name="goto" value="news" />
  <table border="0">
    <tbody>
      <tr>
        <td>username:</td>
        <td>
          <input
            type="text"
            name="acct"
            size="20"
            autocorrect="off"
            spellcheck="false"
            autocapitalize="off"
            autofocus
            autocomplete="off"
          />
        </td>
      </tr>
      <tr>
        <td>password:</td>
        <td>
          <input type="password" name="pw" size="20" autocomplete="off" />
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <input type="submit" value="login" />
</form>
`}</code></pre>
    <p>{`Looking at this HTML tells us HackerNews uses a POST request to to the `}<inlineCode parentName="p">{`/login`}</inlineCode>{` URL to log you in, then it sends a `}<inlineCode parentName="p">{`goto`}</inlineCode>{` field`}<a parentName="p" {...{
        "href": "#fn2"
      }}>{`2`}</a>{`, and two text fields; `}<inlineCode parentName="p">{`acct`}</inlineCode>{` and `}<inlineCode parentName="p">{`pw`}</inlineCode>{`. Whoever wrote this code doesn't believe in typing things out.`}</p>
    <hr></hr>
    <p>{`The Upvote action isn't a form; it's a link that looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<a id="up_14918911" onclick="return vote(event, this, "up")" href="vote?id=14918911&how=up&auth=0855997b736abc0c65600fee44fbf9bbf3bca65c&goto=news"><div class="votearrow" title="upvote"></div></a>
`}</code></pre>
    <p>{`This tells us that voting happens through JavaScript. We can look for the `}<inlineCode parentName="p">{`vote()`}</inlineCode>{` function in `}<a parentName="p" {...{
        "href": "https://news.ycombinator.com/hn.js?S3M7ra4yMVMIVvYSGhjv"
      }}>{`HackerNews's javascript code`}</a>{`. Lucky for us, it is neither obfuscated nor minified. This makes it easy to read right in Chrome DevTools.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/code-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`The `}<inlineCode parentName="p">{`vote()`}</inlineCode>{` function looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function vote(ev, el, how) {
  var id = el.id.split(/_/)[1];
  var up = $('up_' + id);
  vis(up, how == 'un');
  vis($('down_' + id), how == 'un');
  var unv = '';
  if (how != 'un') {
    unv = " | <a id="un_" + id
      + "" onclick="return vote(event, this,\\"un\\")" href=""
      + up.href.replace(" how="up','how=un')" +="" "'="">" + (how == 'up' ? 'unvote' : 'undown') + "</a>"
  }
  $('unv_' + id).innerHTML = unv;
  new Image().src = el.href;
  ev.stopPropagation();
  return false;
}
`}</code></pre>
    <p>{`Most of this code deals with updating the UI. The interesting line is `}<inlineCode parentName="p">{`new Image().src = el.href`}</inlineCode>{`. It tells us that HackerNews upvotes use a GET request to the URL set in the link.`}</p>
    <p>{`In this case, that link is `}<inlineCode parentName="p">{`/vote?id=14918911&how=up&auth=0855997b736abc0c65600fee44fbf9bbf3bca65c&goto=news`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`auth`}</inlineCode>{` argument looks tricky. It's some sort of authentication token making sure these requests don't get forged. Look at other examples on the page, and you'll see the `}<inlineCode parentName="p">{`auth`}</inlineCode>{` token is different on every upvote button.`}</p>
    <p>{`That means it isn't a per-user token, it's a per-user-per-story token. Which means we're going to have to find the URL every time we want to upvote anything.`}</p>
    <h2 {...{
      "id": "inspect-the-request"
    }}>{`Inspect the request`}</h2>
    <p>{`We can confirm our findings by making the actions and inspecting their requests in Chrome DevTools.`}</p>
    <p>{`Due to redirects, you have to enable `}<inlineCode parentName="p">{`Preserve Log`}</inlineCode>{`. Somehow I had never noticed that feature existed before doing this.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/preserve-logs.png",
        "alt": null
      }}></img></p>
    <p>{`As we assumed, the login request sends `}<inlineCode parentName="p">{`goto`}</inlineCode>{`, `}<inlineCode parentName="p">{`acct`}</inlineCode>{`, and `}<inlineCode parentName="p">{`pw`}</inlineCode>{`, and sets a cookie.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/login-request-screenshot.png",
        "alt": null
      }}></img></p>
    <hr></hr>
    <p>{`Inspecting the upvote request follows a similar process. This is what we find:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/upvote-request-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`No surprises here. We have to send a GET request to the upvote URL that's unique for every upvote button. We also send our login cookie so we can assume the server is doing some sort of validation between who's logged in and what the auth token says.`}</p>
    <h2 {...{
      "id": "fake-the-request"
    }}>{`Fake the request`}</h2>
    <p>{`To fake these requests, we use `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`. Login is simple; it looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class HN {
  BaseURL = "https://news.ycombinator.com";

  login(username, password) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
    });

    return fetch(\`\${this.BaseURL}/login\`, {
      method: "POST",
      headers: headers,
      body: convertRequestBodyToFormUrlEncoded({
        acct: username,
        pw: password,
        goto: "news",
      }),
      mode: "no-cors",
      credentials: "include",
    })
      .then((res) => res.text())
      .then((body) => {
        if (body.match(/Bad Login/i)) {
          return false;
        } else {
          return true;
        }
      });
  }
}
`}</code></pre>
    <p>{`We set a `}<inlineCode parentName="p">{`Content-Type`}</inlineCode>{` header to `}<inlineCode parentName="p">{`application/x-www-form-urlencoded`}</inlineCode>{`. Many servers can handle params in any shape they come, but HackerNews is not one of those. This is the only type that works.`}</p>
    <p>{`Our `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` request uses the `}<inlineCode parentName="p">{`POST`}</inlineCode>{` method and our `}<inlineCode parentName="p">{`headers`}</inlineCode>{`, converts our `}<inlineCode parentName="p">{`{acct, pw, goto}`}</inlineCode>{` data object into a URL encoded string, asks the server (or is it the browser?) to please ignore `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Cross-origin_resource_sharing"
      }}>{`CORS`}</a>{`, and we set `}<inlineCode parentName="p">{`credentials: 'include'`}</inlineCode>{` to automagically handle cookies. That's how you expect client-side requests to behave, but you have to explicitly ask for it with `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`.`}</p>
    <p>{`HackerNews responds with either the login page or the news page. If login was successful, we get the news page. Unsuccessful, and we get the login page with a `}<inlineCode parentName="p">{`Bad Login`}</inlineCode>{` text.`}</p>
    <p>{`We look for said `}<inlineCode parentName="p">{`Bad Login`}</inlineCode>{` text to decide if we are now logged in. Hopefully there are no frontpage stories with `}<inlineCode parentName="p">{`Bad Login`}</inlineCode>{` in their title :D`}</p>
    <hr></hr>
    <p>{`Faking an upvote request is more tricky. We have to first fetch the URL.`}</p>
    <p>{`To do that we use `}<a parentName="p" {...{
        "href": "https://github.com/cheeriojs/cheerio"
      }}>{`CheerioJs`}</a>{`, an HTML parser that works in JavaScript and gives us a jQuery-like interface to the document. It's designed to work in node, but you can use the `}<a parentName="p" {...{
        "href": "https://github.com/oyyd/cheerio-without-node-native"
      }}>{`cheerio-without-node`}</a>{` in the browser or React Native.`}</p>
    <p>{`Each HackerNews story can have its own page. This makes our job easier. We can request that page, parse it, and find the upvote button. That looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class HN {
  // ..
  getUpvoteURL(id) {
    return fetch(\`\${this.BaseURL}/item?id=\${id}\`, {
      mode: "no-cors",
      credentials: "include",
    })
      .then((res) => res.text())
      .then((body) => {
        const doc = cheerio.load(body);

        return doc(\`#up_\${id}\`).attr("href");
      });
  }
}
`}</code></pre>
    <p>{`We're making a basic GET request, asking to avoid CORS, and including our credentials. That way HackerNews thinks we're a browser with a logged in user and gives us exactly what it would give to a normal user.`}</p>
    <p>{`We use `}<inlineCode parentName="p">{`cheerio.load`}</inlineCode>{` to parse the HTML and look for the upvote URL with `}<inlineCode parentName="p">{`doc(#up_\${id})`}</inlineCode>{`. Just like we would with jQuery.`}</p>
    <p>{`You can find the correct ID in the upvote button's HTML. Here it is again:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<a id="up_14918911" onclick="return vote(event, this, "up")" href="vote?id=14918911&how=up&auth=0855997b736abc0c65600fee44fbf9bbf3bca65c&goto=news"><div class="votearrow" title="upvote"></div></a>
`}</code></pre>
    <p>{`This part: `}<inlineCode parentName="p">{`<a id="up_..."`}</inlineCode>{`. It's unique for every upvote link and helps us find the right one.`}</p>
    <p>{`To use this link, we issue a `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` request similar to the one we used to find it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class HN {
  // ...
  upvote(id) {
    return this.getUpvoteURL(id)
      .then((url) =>
        fetch(\`\${this.BaseURL}/\${url}\`, {
          mode: "no-cors",
          credentials: "include",
        })
      )
      .then((res) => res.text())
      .then((body) => {
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  }
}
`}</code></pre>
    <p>{`Get the URL, make a fetch, include credentials, assume it worked. HackerNews doesn't give us any real indication that it worked or not. We have to assume.`}</p>
    <p>{`I guess we could re-fetch the item's page and see if that upvote button is still there. 🤔 Sending 2 requests for every upvote feels bad enough, though. No need to make it 3.`}</p>
    <h2 {...{
      "id": "your-new-superpower"
    }}>{`Your new superpower`}</h2>
    <p>{`You can use this approach to reverse engineer any website. If it works on HackerNews, it's going to work everywhere.`}</p>
    <p>{`Apps and websites fundamentally cannot guard against something like this. If legitimate users can use the site, then you can pretend to be a real user and fake those requests. It's just how it is.`}</p>
    <p>{`HackerNews makes it easy. For others, it might be trickier.`}</p>
    <p>{`Use your new superpower responsibly.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/08/mr-robot.jpg",
        "alt": null
      }}></img></p>
    <ol>
      <li parentName="ol">{`There are ways to prevent cross-site requests with `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Cross-origin_resource_sharing"
        }}>{`CORS policies`}</a>{`, domain filtering, and stuff like that. `}<a parentName="li" {...{
          "href": "#ffn1"
        }}>{`↩`}</a></li>
      <li parentName="ol">{`All HN actions have a `}<inlineCode parentName="li">{`goto`}</inlineCode>{` field or argument, I assume it tells the server where to redirect after the request. `}<a parentName="li" {...{
          "href": "#ffn2"
        }}>{`↩`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      